var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucherActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "voucher-active_svg__a",
    x1: "89.052%",
    x2: "2.642%",
    y1: "30.453%",
    y2: "67.764%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4AFFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7DBFCC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4A4A4A"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.3,
    d: "M31 11V1H7v10l-6 4v22h36V15l-6-4zm2.395 4L31 16.596v-3.192L33.395 15zM29 17.93l-10 6.666L9 17.93V3h20v14.93zM7 13.404v3.192L4.606 15 7 13.404zM35 35H3V16.333L19 27l16-10.667V35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6h14v4H12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#voucher-active_svg__a)",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    d: "M1.131 14.728v20.553h34.036V14.728L34 14 18 24.667z",
    transform: "translate(1 1)"
  }))));
}
export default SvgVoucherActive;